import { useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchJvClients, fetchJvSpecStopLossContractsForClient, fetchReadJvClient } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";

const Clients = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();

    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["clients", decouncedSearchValue],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.clientName = decouncedSearchValue;
            }

            return await fetchJvClients({ ...params });
        },

        select: (data) => {
            const clients = data.pages.map((page) => page.rows).flatMap((x) => x).filter(x => Object.keys(x)?.length)
            return {
                count: clients?.length,
                rows: clients

            };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            // console.log({ lastPage })
            const hasMore = lastPage?.rows?.length === 20

            if (!hasMore) return undefined;
            return {
                offset: pages.map(p => p.rows).flat().length
            }
        },
        staleTime: 0,
        enabled: true,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['clientid', 'blkofbusid', 'clientname', 'federaltaxid', 'effectivedate'];

    const onDetailHandler = async (body) => {
        const result = await fetchReadJvClient({ clientId: body.clientid, blkofbusid: body.blkofbusid });
        try {
            const stopLoss = await fetchJvSpecStopLossContractsForClient(result);
            return { ...result, stopLoss };
        } catch (err) {
            return {
                ...result,
                stopLoss: { contracts: [], names: [], errors: [{ name: 'stop-loss', message: err.message }] },
            };
        }
    };

    return (
        <div className={'container '}>
            <p className='title'>Clients</p>
            <p className="sub-title">JV client ( In HRP they are called Accounts) </p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="clientId..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"clients"}
                        disableHeaderFormatting={true}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default Clients